import { useMelioIntl } from '@melio/ar-domain';
import { FundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { GuestPaymentLayout, GuestPaymentLayoutProps } from '../../../layout';
import { AddFundingSourceCardList } from '../components';

export type AddFundingSourceScreenProps = {
  onBack?: VoidFunction;
  billId?: GuestPaymentLayoutProps['billId'];
  isLoading?: boolean;
  onSelect: (fundingSourceType: FundingSource['type']) => void;
};

export const AddFundingSourceScreen = forwardRef<AddFundingSourceScreenProps>(({ onSelect, ...props }, ref) => {
  const { formatMessage } = useMelioIntl();
  return (
    <GuestPaymentLayout
      data-component="AddFundingSourceScreen"
      title={formatMessage('ar.guestPayment.activities.addFundingSrc.methods.title.label')}
      {...props}
      ref={ref}
    >
      <AddFundingSourceCardList onSelect={onSelect} />
    </GuestPaymentLayout>
  );
});
AddFundingSourceScreen.displayName = 'AddFundingSourceScreen';
